export const ALLINGA_URL = "https://www.allinga.fraunhofer.de/";

export const RELEASE_NOTES_URL = "/ReleaseNotes.md";
